import { useMount } from 'react-use';

import {
   PreInterview,
   PreInterviewMarkAsReadCommand,
   PreInterviewQuery,
} from '@dreryk/egabinet-pre-interview-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';

type PreInterviewMarkAsReadProps = {
   readonly preInterview: PreInterview;
};

export const PreInterviewMarkAsRead = (props: PreInterviewMarkAsReadProps): null => {
   const { execute: preInterviewMarkAsRead } = useCqrsCommand<void, void>(
      () => {
         const command = new PreInterviewMarkAsReadCommand();
         command.id = props.preInterview.id;
         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(PreInterviewQuery);
         },
      }
   );

   useMount(() => {
      preInterviewMarkAsRead(undefined);
   });

   return null;
};
